import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import TopMenu from './components/TopMenu';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import HowItWorksPage from './pages/HowItWorksPage';
import TechnologyPage from './pages/TechnologyPage';
import ContactPage from './pages/ContactPage';
import useBrand from './branding/useBrand';
import './App.css';

function App() {
  const brand = useBrand();

  return (
    <BrowserRouter>
      <div className="app-wrap">
        <TopMenu />
        <div className="app-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Legacy actor-split routes - redirect to the new structure */}
            <Route path="/driver-system" element={<Navigate to="/how-it-works#driver-flow" replace />} />
            <Route path="/operator-diagnostics" element={<Navigate to="/product#diagnostics" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <footer className="app-footer py-3 small text-center">
          {brand.footer}
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
